import { render, staticRenderFns } from "./studentCount.vue?vue&type=template&id=d552cc8c"
import script from "./studentCount.vue?vue&type=script&lang=js"
export * from "./studentCount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports